
import GHGeometryObject from './GHGeometryObject';
import Events from '../Events';

export default class GHMaterialListObject extends GHGeometryObject {
  constructor (ghObject, materials) {
    super(ghObject);

    this.materials = materials;
    this.filtered = materials;
    this.keys = [];
    this.values = [];
    this.__selected = 0;
  }

  filter (thickness) {
    this.filtered = this.materials.filter(m => m.thickness === thickness);
    this.keys = this.filtered.map(m => m.name);
    this.values = this.filtered.map(m => m.id);
  }

  get selected () {
    return this.__selected;
  }

  set selected (v) {
    this.__selected = v;
  }

  change (v) {
    this.selected = v;
    this.emit(Events.UI_CHANGE, this);
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/GHMaterialListObject.js